$(document).ready(function () {
    var euShit = readCookie('euShit')
    if (euShit)
      $('.eu-footer').hide()
    else
      $('.eu-footer').show()

console.log(euShit, 'euShit');
    $('.eu-footer .cross').on('click', function (e) {
        e.preventDefault()
        $('.eu-footer').fadeOut()
        createCookie('euShit', 'nasrat')
    })
})


function createCookie(name, value) {
    document.cookie = name + "=" + value + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/eu-footer.js